import {ICurrency} from "./ICurrency";

export const Currencies: { [code: string]: ICurrency } = {
    EUR: {code: "EUR", symbol: "€", symbolBefore: false},
    USD: {code: "USD", symbol: "$", symbolBefore: true},
    CAD: {code: "CAD", symbol: "CA$", symbolBefore: true},
    GBP: {code: "GBP", symbol: "£", symbolBefore: true},
    CHF: {code: "CHF", symbol: "CHF", symbolBefore: true},
    PLN: {code: "PLN", symbol: "zł", symbolBefore: false},
    AUD: {code: "AUD", symbol: "AU$", symbolBefore: true}
};

export function currencyByCode(code: string | undefined | null): ICurrency {
    return (code != undefined && Currencies[code] != undefined) ? Currencies[code] : Currencies.EUR;
}
